import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { TextField } from "@syos-music/form";

import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation ($orderId: ID!, $message: String!) {
    PhoneCallOrder(orderId: $orderId, message: $message) {
      order {
        id
      }
    }
  }
`;

export default function OrderActionPhoneCall({ order, onSubmitted }) {
  const [addPhoneCall] = useMutation(MUTATION);

  return (
    <Form
      onSubmit={({ message }) =>
        addPhoneCall({
          variables: {
            orderId: order.id,
            message,
          },
        })
          .then(() => {
            onSubmitted();
          })
          .catch(() => true)
      }
    >
      {({ handleSubmit, submitting, invalid, pristine }) => (
        <form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                name="message"
                label="Conversation"
                multiline
                required
              />
            </Grid>

            <Grid item xs={12}>
              <LoadingButton
                type="submit"
                loading={submitting}
                disabled={pristine}
              >
                Valider
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
}

OrderActionPhoneCall.fragments = {
  order: gql`
    fragment OrderActions_PhoneCall_order on Order {
      id
    }
  `,
};
